<template>
  <div>
    <TableVisualizationLayout :leftInfo="leftInfo" :leftAction="leftAction">
      <template slot="headerContent">
        <b-col class="pl-0 pr-0">
          <b-row class="mt-2 mb-3" align-h="between">
            <div class="w-100 custom-header-Content">
              <div class="d-flex justify-content-start align-items-center">
                <b-form-input
                  id="input-1"
                  class="text-left custom-search"
                  v-model="filterSearch"
                  type="text"
                  placeholder="Busque por CRM..."
                ></b-form-input>
              </div>
              <div class="competence-guide">
                <div class="p-2 align-self-center">
                  COMPETÊNCIA:
                </div>
                <div class="p-1 align-self-center custom-selected-date">
                  <vue-monthly-picker
                    class="w-100 custom-color-data-picker"
                    v-model="selectedDate"
                    :monthLabels="allMonth"
                    dateFormat="MM/YYYY"
                    :max="maxDate"
                  ></vue-monthly-picker>
                </div>           
              </div>
              <div class="w-100 custom-option">
                <div class="p-2 align-self-center">
                  OPÇÃO ALTERADA:
                </div>
                <b-select v-model="filterTypeId" :options="filterTypes" class="custom-option-select" />
              </div>
              <div class="w-100 d-flex justify-content-end align-items-center ">
                <div @click="onGenerateReport()" class="class-download">
                  <div
                    class="d-flex justify-content-center align-items-center img-custon-principal"
                  >
                    <img
                      class="img-custon"
                      src="@/assets/icons/MDI-microsoft-excel.svg"
                    />
                  </div>
                  <div class="custom-text d-flex align-items-center">
                    Download
                  </div>
                </div>
              </div>
            </div>
          </b-row>
        </b-col>
      </template>
      <template slot="table">
        <div class="scrollme">
          <b-table
            class="table-custom-log spaced-text"
            :fields="fields"
            :items="items"
            v-show="!loading"
            show-empty
            empty-text="Nenhuma informação para exibir!"
          >
            <template #cell(publishMedicalGuide)="data">
              <div
                class="custom-row-table d-flex justify-content-center align-items-center"
              >
                <div
                  :id="'button-' + data.item.id"
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <b-form-checkbox
                    size="lg"
                    class="w-100 "
                    switch
                    v-model="data.item.publishMedicalGuide"
                    :disabled="true"
                  ></b-form-checkbox>
                </div>
              </div>
            </template>

            <template #cell(createdAt)="data">
              <div :id="'div-' + data.item.id">{{ data.item.createdAt }}</div>
              <b-tooltip placement="bottom" :target="'div-' + data.item.id">
                {{ data.item.timeCreatedAt }}
              </b-tooltip>
            </template>

          </b-table>
        </div>
        <div v-show="loading">
          <b-skeleton-table :rows="10" :columns="6"></b-skeleton-table>
        </div>
      </template>
      <template slot="footerContent">
        <div
          class="d-flex bd-highlight mb-3 justify-content-between"
          :class="isMobile() ? 'flex-column-reverse' : 'flex-row'"
          style="width: 100%;"
        >
          <div
            class="mx-auto"
            :class="isMobile() ? '' : 'pagination-log align-self-center'"
          >
            <b-pagination
              v-model="page"
              :total-rows="totalSize"
              :per-page="perPage"
              aria-controls="my-table"
              size="lg"
            />
          </div>
        </div>
      </template>
    </TableVisualizationLayout>
  </div>
</template>

<script>
import _ from "lodash";
import TableVisualizationLayout from "../../../layouts/TableVisualizationLayout.vue";
import {
  allMonth,
  dateToLocaleDateString,
  dateToTime,
} from "../../../utils/date/date-utils";
import { resolve_path_url } from "../../../utils/image/image-utils";
import { isMobile } from "../../../utils/mobile/mobile";
import { anchorBase64Download } from "../../../utils/anchor-base64-download/anchor-base64-download";
import { notificationLogs, notificationReportLogs } from "../../../services/updated-informations/updated-informations-service";
import RoutesPaths from "../../../router/router-structure/routes-paths";

export default {
  components: {
    TableVisualizationLayout,
  },
  mounted() {
    this.allMonth = allMonth();
    this.getNotificationsLog();
  },
  computed: {
    shouldFetchData() {
      return this.filterSearch.length > 2 || this.filterSearch.length === 0;
    },
  },
  watch: {
    page: {
      handler() {
        this.getNotificationsLog();
      },
    },
    filterTypeId: {
      handler() {
        this.getNotificationsLog();
      },
    },
    filterSearch: {
      handler: _.debounce(function () {
        if (this.shouldFetchData) {
          this.getNotificationsLog();
        }
      }, 500), // Espera 500ms antes de chamar a função
      immediate: false,
    },
    selectedDate: {
      handler() {
        this.getNotificationsLog();
      },
    }
  },
  data() {
    return {
      selectedDate: "",
      maxDate: null,
      allMonth: null,
      filterTypes: [
        { value: null, text: "Todos" },
        { value: "ADDRESS", text: "Endereço" },
        { value: "SPECIALTY", text: "Especialidade" },
        { value: "FIELD_ACTIVITY", text: "Área de atuação" },
        { value: "REQUESTED_CHANGES", text: "Solicitou atualizações" },
        { value: "CONFIRMED_INFORMATION", text: "Confirmou as informações" },
        { value: "CLOSED_SCREEN", text: "Fechou a tela" },
      ],
      filterTypeId: null,
      filterSearch: "",
      page: 1,
      perPage: 10,
      totalSize: 10,
      leftAction: {
        text: "Relatório de atualização do guia médico",
        onClick: this.leftActionClickHandler,
      },
      leftInfo: "",
      fields: [
        {
          key: "crm",
          label: "CRM",
          thStyle: { width: "5%" },
        },
        {
          key: "name",
          label: "Nome",
          thStyle: { width: "25%" },
        },
        {
          key: "descriptionType",
          label: "Ação / Opção alterada",
          thStyle: { width: "20%" },
        },
        {
          key: "description",
          label: "Dado alterado",
          thStyle: { width: "20%" },
        },
        {
          key: "publishMedicalGuide",
          label: "Divulga Guia médico",
          class: "text-center",
          thStyle: { width: "15%" },
        },
        {
          key: "createdAt",
          label: "Data e hora",
          class: "text-center",
          thStyle: { width: "15%" },
        },
      ],
      items: [],
      loading: true,
      resolve_path_url,
    };
  },
  methods: {
    isMobile: isMobile,
    async onGenerateReport() {
      const reportResponse = await notificationReportLogs(
        this.perPage,
        this.page - 1,
        this.filterSearch,
        this.selectedDate,
        this.filterTypeId,
      );

      anchorBase64Download(
        null,
        "application/xls",
        "Relatório de atualização do guia médico" + reportResponse.extension,
        reportResponse.fileBase64
      );
    },
    async getNotificationsLog() {
      try {
        this.loading = true;
        const notificationsLogResponse = await notificationLogs(
          this.perPage,
          this.page - 1,
          this.filterSearch,
          this.selectedDate,
          this.filterTypeId,
        );

        this.items = notificationsLogResponse.items;
        this.totalSize = notificationsLogResponse.totalItems;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error("getNotificationsLog", error);
      }
    },
    leftActionClickHandler() {
      this.$router.push(RoutesPaths.contentReportManagement.rootName());
    },
    dateToTime: dateToTime,
    dateToLocaleDate: dateToLocaleDateString,
  },
};
</script>
<style lang="scss">
div.table-custom-log td {
  color: #7a7e83;
  padding-left: 2rem;
}
div.table-custom-log th {
  padding-left: 2rem;
}
.month-picker-wrapper .input {
  max-width: 20rem !important;
  width: 100% !important;
}
.vue-monthly-picker .month-picker-wrapper {
  width: 100% !important;
  min-width: auto !important;
}
</style>
<style lang="scss" scoped>
.pagination-log ul {
  margin-bottom: 0rem;
}
.scrollme {
  overflow-x: auto;
}
.class-download {
  margin-left: 1rem;
  cursor: pointer;
  height: 3.8rem;
  max-width: 13.8rem;
  width: 100%;
  border-radius: 0.5rem;
  display: grid;
  grid-template-columns: 55px auto;
  background: #00995d 0% 0% no-repeat padding-box;
}
.img-custon-principal {
  width: 5rem;
}
.img-custon {
  height: 2.7rem;
  width: 2.4rem;
}
.custom-text {
  color: var(--background-1);
  font-size: multiplier-default-font-size(3); // 16
}
.competence-guide {
  height: 100%;
  display: grid;
  border-style: none;
  grid-column: 0;
  grid-template-columns: 7rem auto;
  align-content: center;
  align-items: center;
  max-width: 28rem;
  width: 100%;
}
.custom-header-Content {
  max-width: 100%;
  display: grid;
  border-style: none;
  grid-column: 0;
}
.cards {
  max-width: 100%;
  display: grid;
  border-style: none;
  grid-column: 0;
}
@media (min-width: 850px) {
  .custom-header-Content {
    grid-template-columns: 25% 30% 30% auto;
  } 
}
.custom-search {
  max-width: 100%;
  margin-right: 2rem;
}
.custom-option {
  height: 100%;
  display: grid;
  border-style: none;
  grid-template-columns: 10rem auto;
  align-content: center;
  align-items: center;
  max-width: 30rem;
  width: 100%;
}
.custom-option-select {
  max-width: 20rem;
  width: 100%;
}
.custom-selected-date {
  max-width: 20rem;
  width: 100%;
}
.custom-color-data-picker {
  background-color: white;
}
</style>
